import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { authUserMetaAtom } from '@/store/authAtoms';
import { useSessionCaps } from '@/hooks/useSessionCaps';

export default function PasswordResetGuard() {
  const location = useLocation();
  const { isGuestSession, isICodeSession } = useSessionCaps();
  const authMeta = useAtomValue(authUserMetaAtom);

  // Restricted sessions (iCode/guest) have no c_user row — flag never applies.
  if (isGuestSession || isICodeSession) {
    return <Outlet />;
  }

  if (authMeta?.passwordMustBeReset && location.pathname !== '/account') {
    const { pathname, search, hash } = location;
    return (
      <Navigate
        to="/account"
        replace
        state={{ forcePasswordReset: true, postResetRedirect: pathname + search + hash }}
      />
    );
  }

  return <Outlet />;
}
